import { Link } from "react-router-dom";

import { RVButton, RVDebouncedInput, RVNestedPageHeader } from "@regal-voice/ui";
import { ADSettingsPaths } from "Pages/settings/Pages/AgentDesktop/paths";
import { SETTINGS_NAV_DESCRIPTIONS_PATCH, SETTINGS_NAV_TITLES } from "Pages/settings/settingsMetadata";
import { ToggleCollapsiblePanelButton, useKnownPanels } from "Utils/CollapsiblePanels";

interface CommunicationTemplatesHeaderProps {
    setFilterValue: (value: string) => void;
    defaultSearch?: string;
}

export function CommunicationTemplatesHeader({
    setFilterValue,
    defaultSearch,
}: CommunicationTemplatesHeaderProps): JSX.Element {
    const { settings } = useKnownPanels();
    const templatesTitle = SETTINGS_NAV_TITLES[ADSettingsPaths.templates];
    const templatesSubtitle = SETTINGS_NAV_DESCRIPTIONS_PATCH[ADSettingsPaths.templates];

    const searchInput = (
        <RVDebouncedInput
            action={setFilterValue}
            placeholder="Search by Template Name"
            size="middle"
            data-testid="search-user"
            defaultValue={defaultSearch}
        />
    );

    const newTemplateButton = (
        <Link to="new">
            <RVButton size="large" type="primary" icon="add-circle-outline" data-testid="new-user-button">
                New Template
            </RVButton>
        </Link>
    );

    return (
        <RVNestedPageHeader
            title={templatesTitle}
            subtitle={templatesSubtitle}
            prefix={<ToggleCollapsiblePanelButton panelName={settings.name} direction="left" />}
            actionRowLeft={searchInput}
            actionRowRight={newTemplateButton}
        />
    );
}
